import type { TestAnswerFeedbackSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import type { ElementFeedbackCss } from 'services/Branding/types'

const AnswerStyled = styled.div<{
  $isVisible?: boolean | null
  $styles?: ElementFeedbackCss<TestAnswerFeedbackSchemaType>
}>`
  display: flex;
  height: 100%;
  width: 100%;
  font-size: ${({ $styles }) => $styles?.common__var?.width};
  transition: width 0.2s;
  align-items: center;
`

export default AnswerStyled
